<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="col-md-12">
        <div class="row align-items-end">
          <!-- align-items-end pour aligner les éléments en bas -->
          <!-- Champ de recherche avec bouton -->
          <div class="col-md-4">
            <div class="d-flex align-items-center">
              <form class="search-bg svg-color pt-3 w-100" @submit.prevent="rechercher">
                <div class="d-flex align-items-center">
                  <input type="text" v-model="searchTerm" @keyup="rechercher"
                    class="form-control shadow-none text-black flex-grow-1" placeholder="Rechercher un inventaire" />
                  <button type="submit" class="bg-transparent text-primary transition p-0 border-0 ms-2">
                    <i class="flaticon-search-interface-symbol"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Champ Multiselect -->
          <div class="col-md-4" v-if="point_ventes.length > 1">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Filtrer par Point de vente
              </label>
              <div style="width: 200px">
                <Multiselect v-model="point_vente" :options="point_ventes" :searchable="true" track-by="label"
                  label="label" placeholder="Sélectionner un point de vente" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Référence
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date de début
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date de fin
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Type
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Magasin
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Statut
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0">
                ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(inventaire, index) in inventaires" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ inventaire.refInventaire }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_date(inventaire.dateDebut) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_date(inventaire.dateFin) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <div>
                  <span class="text-primary" v-if="inventaire.typeInventaire == 'Partiel'">{{ inventaire.typeInventaire
                    }}</span>
                  <span class="text-success" v-if="inventaire.typeInventaire == 'Global'">{{ inventaire.typeInventaire
                    }}</span>
                </div>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span v-if="inventaire.magasin">
                  {{ inventaire?.magasin?.code }} | {{inventaire?.magasin?.nomMagasin}}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <div v-if="inventaire.estCloturer === true">
                  <span class="badge badge-primary">Cloturé</span>
                </div>
                <div v-else>
                  <span class="badge badge-success">En cours</span>
                </div>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0">
                <div class="dropdown">
                  <button class="btn dropdown-toggle btn-primary text-black" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li v-if="checkPermission('ViewInventaire')">
                      <router-link :to="{
                        name: 'DetailInventairePage',
                        params: { id: inventaire.id },
                      }" class="dropdown-item d-flex align-items-center" href="javascript:void(0);">
                        <i class="fa fa-eye lh-1 me-2 position-relative top-1"></i> Détail
                      </router-link>
                    </li>
                    <li v-if="inventaire.estCloturer === true && checkPermission('EditInventaireEtat') && inventaire.estAppliquerStock == false">
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="appliquerInventaireAuStock(inventaire)">
                        <i class="fa fa-check lh-1 me-2 position-relative top-1"></i>
                        Appliquer au stock
                      </a>
                    </li>

                    <!-- <li class="dropdown-item d-flex align-items-center"   v-if="inventaire.estCloturer === true" >
                    <a  type="button" data-bs-toggle="modal" data-bs-target="#AddRapportInventaireModal">
                    <i class="fa fa-pencil lh-2 me-2 position-relative top-1"></i>Rapport Inventaire
                    </a>
                  </li>-->
                    <li v-if="
                      inventaire.estCloturer === true &&
                      inventaire.typeInventaire == 'Partiel'
                    ">
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="generatePDF(inventaire)">
                        <i class="fa fa-print lh-1 me-8 position-relative top-1"></i>
                        Télécharger le rapport
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
  <AddRapportInventaireModal />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import Swal from "sweetalert2";
import { Inventaire } from "@/models/Inventaire";
import { RapportInventaire } from "@/models/RapportInventaire";

import ApiService from "@/services/ApiService";
import { suppression, error, showModal, success } from "@/utils/utils";
import PaginationComponent from "@/components/Utilities/Pagination.vue";
import JwtService from "@/services/JwtService";
import { format_Date, format_date } from "@/utils/utils";
import AddRapportInventaireModal from "../Inventaire/AddRapportInventaireModal.vue";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import Multiselect from "@vueform/multiselect";

export default defineComponent({
  name: "ListeInventaire",
  components: {
    PaginationComponent,
    AddRapportInventaireModal,
    Multiselect,
  },
  setup() {
    let point_vente = ref<string>("");
    let point_ventes = ref([]);

    onMounted(async () => {
      const pointVentes = await JwtService.getPointDeVentes();
      point_ventes.value = pointVentes
        ? pointVentes.map((point: any) => ({
          value: point.id,
          label: point.nomPointVente,
        }))
        : [];
      if (JwtService.getPointDeVente()) {
        point_vente.value = await JwtService.getPointDeVenteId();
      }
      getAllInventaires(point_vente.value);
    });

    const inventaires = ref<Array<Inventaire>>([]);
    const inventaire = ref<Inventaire>();
    const idRapportInventaire = ref(0);

    // BEGIN PAGINATE
    const searchTerm = ref("");
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const selectedItem = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllInventaires(point_vente.value, page_, limit_);
      } catch (error) {
        //
      }
    };

    watch(point_vente, () => {
      rechercher();
    });

    function rechercher() {
      getAllInventaires(point_vente.value, page.value, limit.value, searchTerm.value);
    }

    // END PAGINATE

    const recharger = () => {
      getAllInventaires(point_vente.value);
    };

    function afficher(AddRapportInventaire: RapportInventaire) {
      idRapportInventaire.value = AddRapportInventaire.id;
    }

    function showModalEdite(model: any) {
      showModal(model);
      idRapportInventaire.value = 0;
    }

    function getAllInventaires(point_vent, page = 1, limi = 10, searchTerm = "") {
      return ApiService.get(
        `/all/inventaires?page=${page}&limit=${limi}&mot=${searchTerm}&pointvente=${point_vent}&`
      )
        .then(({ data }) => {
          inventaires.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }

    function moddifier(EditInventaire: Inventaire) {
      inventaire.value = EditInventaire;
      selectedItem.value = EditInventaire.id;
    }

    const generatePDF = async (inventaire) => {
      if (inventaire) {
        console.log(inventaire, "inventaireinventaireinventaire");
        const doc = new jsPDF({
          orientation: "landscape",
        });
        const user = [];
        inventaire.equipes.map((equipe, index) =>
          user.push(equipe.user.nom + " " + equipe.user.prenom)
        );
        const role = [];
        inventaire.equipes.map((equipe, index) => role.push(equipe.role.nom));

        const pageWidth = doc.internal.pageSize.getWidth();
        doc.setFont("helvetica");
        doc.setFontSize(12);
        doc.text(`Agence: ${inventaire.pointvente.nomPointVente}`, 10, 15);
        const dateStr = new Date().toLocaleDateString();
        doc.text(`le ${dateStr}`, pageWidth - 60, 15);

        // Titre "inventaire"
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(
          `Rapport de l'inventaire ${inventaire.typeInventaire} du ${format_date(
            inventaire.dateDebut
          )} au ${format_date(inventaire.dateFin)}`.toUpperCase(),
          pageWidth / 2,
          25,
          { align: "center" }
        );

        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text(`Inventaire N° : ${inventaire.refInventaire}`, 10, 35);
        doc.text(
          `Magasin : ${inventaire.magasin.magasin.nomMagasin} ${inventaire.magasin.nomMagasin}`,
          10,
          40
        );

        // Tableau des produits
        autoTable(doc, {
          head: [
            [
              "N°",
              "Produits",
              "Stock Log",
              "Stock Fiche",
              "Stock Ven.",
              "Ecart fiche",
              "Ecart Log",
              "Ecart Réel",
              "Observation",
            ],
          ],
          body: inventaire.inventaiprocondimags.map((produit, index) => [
            index + 1,
            produit.nomProd,
            produit.qteLogique,
            produit.qteFiche,
            produit.qtePhysique,
            produit.ecartLogique,
            produit.ecartFiche,
            produit.ecartReel,
            produit.observation,
          ]),
          startY: 45,
          margin: { left: 10, right: 10 },
          theme: "grid",
          styles: { fontSize: 10 },
          headStyles: { fillColor: [189, 185, 185] },
        });
        autoTable(doc, {
          body: [role, user],
          theme: "plain",
          styles: {
            fontSize: 10,
            halign: "center",
            cellPadding: { top: 10, right: 0, bottom: 10, left: 0 },
          },
          bodyStyles: { fontStyle: "bold" },
          tableLineColor: [0, 0, 0],
        });
        // Footer
        const dateTimeStr = new Date().toLocaleString();
        const pageCount = doc.getNumberOfPages();
        const footerY = doc.internal.pageSize.height - 10;
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.text(`Date : ${dateTimeStr}`, 10, footerY);
        doc.text(`Page ${pageCount}`, pageWidth - 20, footerY);

        doc.save(`inventaire_${inventaire.refInventaire}.pdf`);
      } else {
        console.error("inventaire non trouvée");
      }
    };

    const deleteInventaire = (id: number) => {
      ApiService.delete(`/inventaires/${id}`)
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            toast: true,
            icon: "success",
            title: "General Title",
            animation: false,
            position: "top-right",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            heightAuto: false,
          });
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Réssayer à nouveau!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });

      for (let i = 0; i < inventaires.value.length; i++) {
        if (inventaires.value[i].id === id) {
          inventaires.value.splice(i, 1);
        }
      }
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    };

    const appliquerInventaireAuStock = (item: Inventaire) => {
      Swal.fire({
        text: "Vous êtes sur le point d'appliquer cet inventaire au stock. Êtes-vous sûr ?",
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: "Appliquer",
        cancelButtonText: "Annuler",
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          ApiService.put(`/inventaires/${item.id}/appliquer-stock`, {})
            .then(({ data }) => {
              success(data.message || "Inventaire appliqué au stock avec succès");
              recharger();
            })
            .catch(({ response }) => {
              error(response?.data?.message || "Une erreur est survenue lors de l'application.");
            });
        }
      });
    };

    return {
      generatePDF,
      inventaires,
      checkPermission,
      getAllInventaires,
      deleteInventaire,
      moddifier,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
      selectedItem,
      recharger,
      point_ventes,
      point_vente,
      format_Date,
      format_date,
      idRapportInventaire,
      afficher,
      appliquerInventaireAuStock,
    };
  },
});
</script>
